import React from 'react'

function Faq() {
    return (
        <section className='faq position-relative'>
            <span></span>
            <div className="container">
                <div className="row d-flex align-items-center">
                    <div className="col-lg-6 col-md-6">
                        <div className="port2">
                            <div className="d-flex gap-3 align-items-center">
                                <hr className='hr3' />
                                <h3 className='heading1 m-0'>FAQ</h3>
                            </div>
                            <h2>
                                Frequently Asked Questions
                            </h2>
                            <p style={{ padding: '0px 123px 0px 0px' }}>
                                Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text ever.
                            </p>
                        </div>
                    </div> {/* data-aos="fade-up" data-aos-easing="ease" data-aos-duration="1700" */}
                    <div className="col-lg-6 col-md-6">
                        <div class="accordion d-flex flex-column gap-4" id="accordionPanelsStayOpenExample"> {/* data-aos="fade-down" data-aos-easing="ease" data-aos-duration="1900" */}
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingOne">
                                    <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseOne" aria-expanded="true" aria-controls="panelsStayOpen-collapseOne">
                                        What services does your software house offer?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseOne" class="accordion-collapse collapse show" aria-labelledby="panelsStayOpen-headingOne">
                                    <div class="accordion-body">
                                        <p>We offer a wide range of services including web and mobile app development, custom software solutions, UI/UX design, and digital marketing to help your business grow.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingTwo">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseTwo" aria-expanded="false" aria-controls="panelsStayOpen-collapseTwo">
                                        How do you ensure the quality of your software projects?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseTwo" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingTwo">
                                    <div class="accordion-body">
                                        <p>We follow a rigorous quality assurance process, including thorough testing, code reviews, and client feedback, to ensure that the final product meets your expectations and industry standards.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingThree">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseThree" aria-expanded="false" aria-controls="panelsStayOpen-collapseThree">
                                        How long does it take to complete a software project?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseThree" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingThree">
                                    <div class="accordion-body">
                                        <p>The timeline depends on the complexity of the project and your specific requirements. We work closely with clients to provide a realistic project timeline and keep you updated throughout the process.</p>
                                    </div>
                                </div>
                            </div>
                            <div class="accordion-item">
                                <h2 class="accordion-header" id="panelsStayOpen-headingFour">
                                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#panelsStayOpen-collapseFour" aria-expanded="false" aria-controls="panelsStayOpen-collapseFour">
                                        Do you offer post-launch support and maintenance?
                                    </button>
                                </h2>
                                <div id="panelsStayOpen-collapseFour" class="accordion-collapse collapse" aria-labelledby="panelsStayOpen-headingFour">
                                    <div class="accordion-body">
                                        <p>Yes, we provide ongoing support and maintenance services to ensure your software runs smoothly and is updated with the latest features and security patches.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Faq
